import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input, OnChanges,
  OnDestroy,
  OnInit,
  Output, SimpleChanges,
  ViewChild
} from '@angular/core';
import {FormioCustomComponent} from "@formio/angular";
import {RequestService} from "../../../../core/services/request/request.service";
import {PortalBaseComponent} from "../../../../core/components/portal-base/portal-base.component";
import {PortalService} from "../../../../core/services/portal/portal.service";
import {FeatureFlagsService} from "../../../../core/services/feature-flag/feature-flags.service";
import {TableGridComponent} from "../../../../core/components/data-grids/table-grid/table-grid.component";

// We really don't want to use jQuery on the Angular side
declare var $: any;

@Component({
  selector: 'sb-portal-list,sb-dynamic-portal-list',
  templateUrl: './portal-list.component.html',
  styleUrls: ['./portal-list.component.scss']
})
export class PortalListComponent extends PortalBaseComponent implements FormioCustomComponent<string>, OnInit, AfterViewInit, OnChanges, OnDestroy {

  @ViewChild('target')
  target: ElementRef<HTMLElement>;

  @Input()
  disabled: boolean;

  @Input()
  value: string;

  @Output()
  valueChange: EventEmitter<string> = new EventEmitter<string>();

  @Input()
  Table: string;

  @Input()
  Query: string;

  @Input()
  Columns: string;

  @Input()
  SortOrder: string;

  @Input()
  parameters: any;

  @Input()
  parametersJSON: string;

  @Input()
  preview: boolean;

  knockoutTemplateRendered: boolean = false;

  constructor(private requestService: RequestService,
              public portalService: PortalService,
              public featureFlagsService: FeatureFlagsService,
              public hostElement: ElementRef) {
    super(portalService, hostElement);
  }

  ngOnInit(): void {
    super.init();
  }

  async ngAfterViewInit() {
    this.renderKnockoutTemplate();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.renderKnockoutTemplate();
  }

  ngOnDestroy(): void {
    super.destroy();
  }

  async refresh() {
    const tableGrid = $(this.hostElement.nativeElement).find("sb-ng-table-grid")[0] as TableGridComponent;
    if (tableGrid) {
      tableGrid.embeddedListRefresh = new Date().getTime().toString();
    }
  }

  private async renderKnockoutTemplate() {
    if (this.Table && !this.knockoutTemplateRendered) {
      const element = this.target.nativeElement;

      const parameters = {
        table: this.Table,
        query: this.Query,
        columns: this.Columns,
        sortOrder: this.SortOrder,
      };

      const response: any = await this.requestService.createRequest()
        .controller("servicely.core.Portal")
        .method("getPortalList")
        .data(parameters)
        .execute();

      const data: any = JSON.parse(response.data);

      data.elements[0].rendererProperties['showQueryBuilder'] = 'false';
      data.elements[0].rendererProperties['showListToolbar'] = 'true';

      // Magic property to indicate the list is coming from the Portal
      data.elements[0].rendererProperties['isPortalComponent'] = 'true';


      const templateParams = {
        rendererProperties: {
          tile: "ListAutoScaffold",
        },
        elements: [data],
      };
      (window as any).KO.cleanNode(element);
      (window as any).KO.renderTemplate("container-standard", templateParams, {}, element, "replaceNode");

      this.knockoutTemplateRendered = true;
    }
  }

  private locateKoBindingFunction(elem: Element, func: string): { context: any, func: string} | null {
    let binding: { context: any, func: string} | null = {context: null, func: null};
    this.locateKoBindingFunction0(elem, func, binding);

    return binding && binding.context && binding.func ? binding : null;
  }

  private locateKoBindingFunction0(elem: Element, func: string, binding: any) {
    const data = (window as any).KO.dataFor(elem);
    if (data && data[func] && typeof data[func] === "function") {
      binding.context = data;
      binding.func = func;
    } else {
      Array.from(elem.children).forEach((e) => {
        this.locateKoBindingFunction0(e, func, binding);
      });
    }
  }


}
